import { render } from "./FlatCard.vue?vue&type=template&id=6f17ac3e&scoped=true"
import script from "./FlatCard.vue?vue&type=script&lang=js"
export * from "./FlatCard.vue?vue&type=script&lang=js"

import "./FlatCard.vue?vue&type=style&index=0&id=6f17ac3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\ametist.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f17ac3e"]])

export default __exports__